// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, {
  // Navigation,
  // Pagination,
  Autoplay,
  Controller,
  Thumbs,
  // EffectCoverflow,
  EffectFade,
} from "swiper";
import { isMobile } from "./isMobile";

// configure Swiper to use modules
Swiper.use([
  // Navigation,
  // Pagination,
  Autoplay,
  Controller,
  Thumbs,
  // EffectCoverflow,
  EffectFade,
]);

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  var swiperGallery = document.querySelector(".gallery-top");

  if (swiperGallery) {
    var swiperThumbs = new Swiper(".gallery-thumbs", {
      slidesPerView: 1,
      spaceBetween: 0,
      preventClicksPropagation: false,
      preventClicks: false,
      allowTouchMove: false,
      touchRatio: 0,
      autoplay: {
        delay: 3500,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          autoplay: false,
        },
      },
    });

    new Swiper(swiperGallery, {
      slidesPerView: 1,
      spaceBetween: 0,
      preventClicksPropagation: false,
      preventClicks: false,
      allowTouchMove: false,
      touchRatio: 0,
      autoplay: {
        delay: 3500,
      },
      breakpoints: {
        768: {
          autoplay: false,
        },
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  }
});

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $anchor = $(".gallery-top");

  if (!$anchor.length || isMobile()) {
    return false;
  }

  $(".swiper-wrapper-img div:eq(0)").addClass("active");
  $(".swiper-wrapper-thumbs a").each(function (index, value) {
    var link = $(this).attr("data-img");
    var id = "#" + link;

    $(this).on("mouseenter", function () {
      $(".swiper-wrapper-thumbs a.active").removeClass("active");
      $(this).addClass("active");

      $(".swiper-wrapper-img").each(function (index, value) {
        $(this).find("div").removeClass("active");
        $(this).find(id).addClass("active");
      });
    });
  });
});
